// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2EVJ8","container":"styles_container__2a9F8","title":"styles_title__3t17r","wrapper":"styles_wrapper__3sAKq","answer":"styles_answer__2S3wl"};